import React from 'react'
import { useNavigate } from 'react-router-dom'
import './Top_Heading.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Black_Btn from '../../common_components/common_btn/black_btn/Black_Btn'
import { faPhone } from '@fortawesome/free-solid-svg-icons'
import { formatDate } from '../../../utils/common'

const Top_Heading = ({ order, data }) => {

    const navigate = useNavigate()
    return (
        <section className="Top_Heading">
            <div className='container'>
                <div className='content_holder'>
                    <div className='top_div'>
                        <p className='order_id'>{`Order ID #${order?.invoice_no || order?.Product_Order?.invoice_no}`}</p>
                        <p className='date_text'>{formatDate(order?.createdAt)}</p>
                    </div>
                    <div className='bottom_div'>
                        <p className='order_id'>₹ {data?.total_amount}</p>

                        <div className='right_div'>
                            <div className='call_text'>
                                <FontAwesomeIcon icon={faPhone} className='call_icon' />
                                <span className='inner_text'>+{order?.delivery_boy?.contact_no}</span>
                            </div>

                            <Black_Btn btnText="Processing your order" />

                        </div>

                    </div>
                </div>
            </div>
        </section>
    )
}

export default Top_Heading
